import { fork } from "redux-saga/effects";

import watchUsers from "./components/user/sagas";

const watchSystem = [fork(watchUsers)];

export { watchSystem };
